(function () {
  function parsePositiveInt(value, fallback) {
    const n = parseInt(value, 10);
    return Number.isFinite(n) && n > 0 ? n : fallback;
  }

  function parseNonNegativeInt(value, fallback) {
    const n = parseInt(value, 10);
    return Number.isFinite(n) && n >= 0 ? n : fallback;
  }

  function init(root) {
    const sectionId = root.dataset.sectionId;
    const grid = root.querySelector('[data-collection-product-grid]');
    const btn = root.querySelector('[data-collection-load-more-btn]');
    const countEl = root.querySelector('[data-collection-load-more-count]');
    if (!sectionId || !grid || !btn || !countEl) return;

    let currentPage = parsePositiveInt(root.dataset.currentPage, 1);
    const totalPages = parsePositiveInt(root.dataset.totalPages, 1);
    let shown = parseNonNegativeInt(root.dataset.shownCount, grid.childElementCount);
    const total = parseNonNegativeInt(root.dataset.totalProducts, shown);

    function syncButton() {
      if (currentPage >= totalPages) {
        btn.hidden = true;
      } else {
        btn.hidden = false;
      }
    }

    function renderCount() {
      const template = root.dataset.countTemplate || 'Showing [shown] of [total] products';
      countEl.textContent = template.split('[shown]').join(String(shown)).split('[total]').join(String(total));
    }

    renderCount();
    syncButton();

    btn.addEventListener('click', async () => {
      if (currentPage >= totalPages || btn.disabled) return;

      const nextPage = currentPage + 1;
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');

      try {
        const url = new URL(window.location.href);
        url.searchParams.set('page', String(nextPage));
        url.searchParams.set('sections', sectionId);

        const response = await fetch(url.toString());
        if (!response.ok) throw new Error('Request failed');

        const data = await response.json();
        const html = data[sectionId];
        if (!html || typeof html !== 'string') throw new Error('Invalid section response');

        const doc = new DOMParser().parseFromString(html, 'text/html');
        const incoming = doc.querySelector('[data-collection-product-grid]');
        if (!incoming) throw new Error('Missing grid markup');

        const added = incoming.childElementCount;
        grid.append(...Array.from(incoming.children));

        shown += added;
        currentPage = nextPage;
        root.dataset.currentPage = String(currentPage);
        root.dataset.shownCount = String(shown);

        renderCount();
        syncButton();
      } catch {
        btn.hidden = false;
      } finally {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
      }
    });
  }

  document.querySelectorAll('[data-collection-load-more-root]').forEach(init);
})();
